/* jshint esversion: 11 */
import { createRouter, createWebHistory } from "vue-router";
import Datenschutz from "../views/Datenschutz.vue";

import loginRoutes from "./loginRoutes";
import calculationRoutes from "./calculationRoutes";
import baseRoutes from "@/router/baseRoutes";

import { useAuthStore } from "@/stores/authStore";
import { useSpaceStore } from "@/stores/spaceStore";
import { node } from "@sentry/core";
import { useMainStore } from "@/stores/mainStore";

const routeElements = [];
routeElements.push(...baseRoutes);
routeElements.push(...loginRoutes);
routeElements.push(...calculationRoutes);
routeElements.push({
  path: "/datenschutz",
  name: "datenschutz",
  component: Datenschutz,
  meta: { global: true }
});

const router = createRouter({
  // import.meta.env.BASE_URL
  history: createWebHistory(),
  routes: routeElements,
  duplicateNavigationPolicy: "reload"
});

router.beforeEach(async (to, from) => {
  const authStore = useAuthStore();

  if (to.meta.global) {
    return true;
  }

  if (!to.meta.noAuth && !authStore.loggedIn) {
    localStorage.setItem("restoreURL", to.path);
    return { name: "login" };
  }

  if (to.meta.noAuth && authStore.loggedIn) {
    return { name: "base-data" };
  }
});

router.beforeResolve(async (to, from) => {
  // console.log("beforeResolve", to);
  const mainStore = useMainStore();

  if (!to.meta.calc) {
    mainStore.activeSpaceId && mainStore.exitSpace();
    return true;
  }

  // TODO find better way to prevent en error if element is missing
  const spaceStore = useSpaceStore();
  const authStore = useAuthStore();
  const nodeId = (to.params.nodeId ?? "")
    .replace("manufacturingStep", "part")
    .replace("variant", "part");

  const spaceId = to.params.spaceId ?? "";

  if (spaceId && mainStore.activeSpaceId !== spaceId) {
    await mainStore.openSpace(spaceId);
  }

  if (!spaceId && mainStore.activeSpaceId) {
    mainStore.leaveSpace();
    return false;
  }

  if (nodeId && !spaceStore.calculationElements.hasOwnProperty(nodeId)) {
    return { name: "base-data", params: { spaceId } };
  }
  return true;
});

export default router;
